<template>
    <div>
        <div v-if="showList">
            <grid id="myGrid" class="m-0" :tableConfigVisible="tableConfigVisible" :columns="gridColumns" :data="gridData" :permissions="permissions" :user="user" :users="users" :page="pageIs" @editForm="editForm($event)" @deleteForm="deleteForm($event)"></grid>
        </div>
        <div v-else>
            <div class="row pageHeader py-2 currentTab">
                <button class="btn tabBtn mr-2" @click="changeTab('form')" :class="{active:currentTab=='form'}">
                    <span class="tab-number mr-1">1</span> Form
                </button>
                <button class="btn tabBtn mr-2" @click="changeTab('workflow')" :class="{active:currentTab=='workflow'}">
                    <span class="tab-number mr-1">2</span> {{this.$ml.get('WORKFLOW')}}
                </button>
                <button class="btn tabBtn" @click="changeTab('permission')" :class="{active:currentTab=='permission'}">
                    <span class="tab-number mr-1">3</span> {{this.$ml.get('PERMISSIONS')}}
                </button>
            </div>
            <div class="container" v-show="currentTab==='form'">
                <div class="scrollable pb-5">
                    <div class="container-fluid">
                        <input type="text" class="formHead my-3" placeholder="Form Adını Yazınız" v-model="formName">
                    </div>
                    <div class="px-3">
                        <FormBuilder id="formBuilder" v-model="configuration"></FormBuilder>
                        <!-- <div class="px-3">
                            <div class="add-table-section" v-if="!showTable" @click="showTable=!showTable">
                                <span><i class="fas fa-plus-circle mr-1" style="font-size:24px;"></i>{{$ml.get("ADD_TABLE")}}</span>
                            </div>
                            <div class="table-content" v-if="showTable">
                                <div class="configure-table">
                                    <button class="btn btn-info mr-1" data-toggle="modal" data-target="#changeTableName"><i class="fas fa-cog mr-1"></i>{{$ml.get('CONFIGURATION')}}</button>
                                    <button class="btn btn-danger" @click="showTable=!showTable, tableName='New Table'"><i class="fas fa-trash-alt mr-1"></i>{{$ml.get('DELETE')}}</button>
                                </div>
                                <table-editor :tableName="tableName" :tableData="tableData" @sendJson="getTableData($event)" :isBuildMode="true"></table-editor>
                            </div>
                        </div>
                        <div class="px-3 mt-3">
                            <div class="add-table-section" v-if="!showFile" @click="showFile=!showFile">
                                <span><i class="fas fa-plus-circle mr-1" style="font-size:24px;"></i>Dosya Ekle</span>
                            </div>
                            <div class="table-content" v-if="showFile">
                                <div class="configure-table">
                                    <button class="btn btn-danger" @click="showFile=!showFile, fileName=''"><i class="fas fa-trash-alt mr-1"></i>{{$ml.get('DELETE')}}</button>
                                </div>
                                <h2>Dosya</h2>
                                <div class="input-group w-100 mt-2">
                                    <div class="custom-file">
                                        <input type="file" class="custom-file-input" id="inputGroupFile02" @change="chooseFile($event)">
                                        <label class="custom-file-label mb-0" for="inputGroupFile02" aria-describedby="inputGroupFileAddon02">{{file.name || "Seçili dosya yok"}}</label>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
                <div class="pageFooter">
                    <div class="container d-flex justify-content-end">
                        <button class="btn btn-light mr-1 px-3 bg-white" @click="clearForm"><i class="far fa-arrow-left mr-2" style="font-weight:700;"></i>{{this.$ml.get('BACK')}}</button>
                        <button class="btn btn-primary px-4" @click="changeTab('workflow')">{{this.$ml.get('CONTINUE')}}<i class="far fa-arrow-right ml-2" style="font-weight:700;"></i></button>
                    </div>
                </div>
            </div>
            <div v-show="currentTab==='workflow'">
                <formWorkflow id="formWorkflow" :flow="workflowSteps" :formConfiguration="configuration" @flow="workflowStepsObj($event)"/>
            </div>
            <div v-show="currentTab==='permission'">
                <formPermissions id="formPermissions" :formConfiguration="configuration" :flow="workflowSteps" :formPermissions="formPermissions" :buttonConfig="buttonConfig" :isUpdateMode="isUpdateMode" :isTableAdded="showTable" :tableName="tableName" :tableData="tableData" :tablePermissions="tablePermissions" :isFileAdded="showFile" :filePermissions="filePermissions"  @permissions="createForm($event)" @updateForm="updateFormF($event)" @cancel="clearForm"/>
            </div>
        </div>
        <notifications group="foo" style="margin-right:5%;margin-top:5%" position="top right" />

        <div class="modal" tabindex="-1" id="changeTableName">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h6>Table Name</h6>
                    </div>
                    <div class="modal-body">
                        <input class="new-input bg-white" type="text" v-model="tableHeadline">
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-primary" @click="changeTableName">Save changes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
    import axios from 'axios'
    import { mapState } from 'vuex'
    import Header from './header'
    import { FormBuilder } from 'v-form-builder'
    import { FormRenderer } from 'v-form-builder'
    import FormWorkflow from './formGeneratorFlow.vue'
    import FormPermissions from './formGeneratorPermissions.vue'
    import Grid from './Grid'
    import TableEditor from './tableEditorTest.vue'
    
    export default {
        name: "formGenerator",
        components: {
            Header,
            FormBuilder,
            FormRenderer,
            FormWorkflow,
            FormPermissions,
            Grid,
            TableEditor
        },
            data () {
            return {
                configuration: {
                    formConfig: {},
                    sections: {},
                    rows: {},
                    controls: {},
                },
                workflowData: null,
                formData: null,
                formInputData: null,
                formName: '',
                updateFormId: '',
                forms: [],
                showFlow: false,
                showRenderer: false,
                isEditMode: false,
                formPermissions: {},
                firstLoad:true,
                tableConfigVisible: [],
                gridColumns: [
                    {prop:'_id',name:"Id"},
                    {prop:'name',name:"Form Adı",type:"name", default:true,valid:true},
                    {prop:'add_date', name: this.$ml.get('CREATION_DATE'),type: "dateObj", default:true},
                    {prop:"cuid", name: this.$ml.get('CREATED_BY'), type: "user", default:true },
                ],
                gridData:[],
                contactsRow:[],
                pagingSize:30,
                pagingOffset:0,
                user: [],
                users: [],
                permissions: [],
                pageIs: 'forms',
                showList: true,
                currentTab: 'form',
                workflowSteps: {
                    'steps':{
                        'start':{
                            assignees:[],
                            id:'start',
                            name:this.$ml.get('START') 
                        },
                        'completed':{
                            assignees:[],
                            id:'completed',
                            name:this.$ml.get('COMPLETED')  
                        }
                    },
                    'sequence':[
                        'start',
                        'completed'
                    ]
                },
                formPermissions: {},
                buttonConfig: {},
                isUpdateMode : false,
                showTable: false,
                tableName: "New Table",
                tableHeadline: "",
                tableData: [ {} ],
                tablePermissions: {},
                showFile: false,
                file: {},
                filePermissions:{},
            }
        },
        computed:{
            ...mapState([
                'baseUrl',
                'windowWidth',
                'maxMobilSize',
                'maxTabletSize'
            ]),
        },
        created() {
            this.$root.$refs.formGenerator = this
        },
        methods: {
            changeTab(tab) {
                if(tab !== "form"){
                    if( !this.configuration['sections'] || Object.keys(this.configuration['sections']).length == 0) {
                        this.$notify({
                            group: "foo",
                            type: "warn",
                            title: "Lütfen bir form oluşturunuz!",
                        });
                    }
                    else if(this.formName === ""){
                        this.$notify({
                            group: "foo",
                            type: "warn",
                            title: "Lütfen form ismini giriniz!",
                        });
                    }
                    else if(!this.checkRelatedInputs()){
                        this.$notify({
                            group: "foo",
                            type: "warn",
                            title: "Kişi, firma ve fırsat alanlarından en fazla birer tane ekleyebilirsiniz!",
                        });
                    }
                    else{
                        this.configuration['formConfig']['headline'] = this.formName
                        this.configuration['formConfig']['isShowHeadline'] = true
                        this.currentTab = tab
                    }
                }
                else{
                    this.currentTab = tab
                }
            },
            editForm(event) {
                this.getFormF(event)
            },
            updateConfiguration(object){
                this.configuration = object
            },
            createForm(obj){
                var form = {}

                form.name = this.configuration.formConfig.headline
                form.data = this.configuration
                form.flow = this.workflowSteps
                // form.permissions = obj["permissions"]
                form.buttonConfig = obj["buttonConfig"]
                // form.tableObject = obj["tableObject"]
                // form.fileObject = obj["fileObject"]
                
                let data = this.convertIds(form.data)
                form.data = data
             
                console.log(form);
                axios({
                    method:'POST',
                    url:'/addForm',
                    baseURL: this.baseUrl,
                    data: form,
                    withCredentials:true
                    }).then((res)=>{
                        return res
                    }).then((res)=>{
                    if(res.data.status){
                        if(res.data.status.code==0){
                            this.getFormsF()
                            this.$emit("changeHeader")
                            this.showList = true
                            this.clearForm()
                        }else{

                        }
                    }else{

                    }
                })
            },
            updateFormF(obj){
                var form = {}

                form.name = this.configuration.formConfig.headline
                form.data = this.configuration
                form.flow = this.workflowSteps
                // form.permissions = obj["permissions"]
                form.buttonConfig = obj["buttonConfig"]
                // form.tableObject = obj["tableObject"]
                // form.fileObject = obj["fileObject"]
                form.formId = this.updateFormId

                let data = this.convertIds(form.data)
                form.data = data

                console.log(form);
                
                axios({
                    method:'POST',
                    url:'/updateForm',
                    baseURL: this.baseUrl,
                    data: form,
                    withCredentials:true
                    }).then((res)=>{
                        return res
                    }).then((res)=>{
                    if(res.data.status){
                        if(res.data.status.code==0){
                            this.getFormsF()
                            this.$emit("changeHeader")
                            this.showList = true
                            this.clearForm()
                            this.isUpdateMode = false
                        }else{
                            
                        }
                    }else{

                    }
                })
            },
            deleteForm(id){
                let obj = {}
                for(let item of this.forms){
                    if(id == item._id.$oid) {
                        obj.formId = id
                        obj.name = item.name
                        obj.data = item.data
                        obj.flow = item.flow
                        obj.permissions = item.permissions
                        obj.buttonConfig = item.buttonConfig
                        // obj.tableObject = item.tableObject
                        obj.isActive = false
                    }
                }
                
                axios({
                    method:'POST',
                    url:'/updateForm',
                    baseURL: this.baseUrl,
                    data: obj,
                    withCredentials:true
                    }).then((res)=>{
                        return res
                    }).then((res)=>{
                    if(res.data.status){
                        if(res.data.status.code==0){
                            this.getFormsF()
                        }else{
                            
                        }
                    }else{

                    }
                })
            },
            convertIds(data) {
                var sectionIds = Object.keys(data.sections)
                var controlIds = Object.keys(data.controls)

                sectionIds.forEach(sectionId => {
                    if(data.sections[sectionId].type == 'table'){
                        for(let item of data.sections[sectionId].tableObject.data){
                            const tempId = item.$id
                            delete item.$id
                            item.id = tempId
                        }
                    }
                });

                controlIds.forEach(controlId => {
                    if(data.controls[controlId].type == 'radio'){
                        for(let item of data.controls[controlId].items){
                            for(let section of item.show_section) {
                                if(section.type == "table"){
                                  for(let row of section.tableObject.data){
                                    const tempId = row.$id
                                    delete row.$id
                                    row.id = tempId
                                  }  
                                }
                            }
                        }
                    }
                });
                
                return data
            },
            clearForm(){
                this.currentTab = 'form'
                this.configuration = {}
                this.formName = ''
                this.showList = true
                this.isEditMode = false
                this.showTable = false
                this.updateFormId = ''
                this.tableName = 'New Table'
                this.showFile = false
                this.file = {}
    
                this.$emit("changeHeader")
                this.workflowSteps = {
                    'steps':{
                        'start':{
                            assignees:[],
                            id:'start',
                            name:'Start'  
                        },
                        'completed':{
                            assignees:[],
                            id:'completed',
                            name:'Completed'  
                        }
                    },
                    'sequence':[
                        'start',
                        'completed'
                    ]
                }
            },
            getFormsF(){
                axios({
                    method:'POST',
                    url:'/getAllForms',
                    baseURL: this.baseUrl,
                    withCredentials:true
                    }).then((res)=>{
                        return res
                    }).then((res)=>{
                    if(res.data.status){
                        if(res.data.status.code==0){
                            this.forms = res.data.content.forms[0]
                            if(this.firstLoad){
                                for(var col in this.gridColumns){
                                    if(this.gridColumns[col]['default']){
                                        this.tableConfigVisible.push(this.gridColumns[col]['prop'])
                                    }
                                }
                            }
                            this.firstLoad=false
                            if(res.data.content.forms){
                                var formList = []
                                let columns = this.gridColumns
                                for (var formObjIter in res.data.content.forms[0]){
                                    this.contactsRow.push(res.data.content.forms[0][formObjIter])
                                    let obj={}
                                    let formObj =res.data.content.forms[0][formObjIter]
        
                                    
                                    for(var column in columns){
                                        var colInActivity = formObj.hasOwnProperty(columns[column]['prop'])
                                        if(colInActivity){
                                            
                                            let edObj={}
                                            
                                            edObj['val']=formObj[columns[column]['prop']]
                                            
                                            edObj['isEditMode']=false
                                            edObj['type']=columns[column]['type']
                                            obj[columns[column]['prop']]=edObj
                                        }else{
                                            let edObj={}
                                            edObj['val']=null
                                            edObj['isEditMode']=false
                                            edObj['type']=columns[column]['type']
                                            
                                            if(columns[column]['type']=='dateObj'){
                                                let date = {}
                                                date['$date']=''
                                                edObj['val']=date
                                            }
                                            obj[columns[column]['prop']]=edObj
                                        }
                                    }
                                    formList.push(obj)
                                    
                                }
                                this.gridData = formList
                                formList.reverse()
                                this.showList = true
                                this.currentTab = 'form'
                            }
                        }else{

                        }
                    }else{

                    }
                })
            },
            getFormF(id){
                axios({
                    method:'POST',
                    url:'/getForm',
                    baseURL: this.baseUrl,
                    data:{
                        formId:id
                    },
                    withCredentials:true
                    }).then((res)=>{
                        return res
                    }).then((res)=>{
                    if(res.data.status){
                        if(res.data.status.code==0){
                            this.configuration = res.data.content.form.data
                            this.formName = res.data.content.form.data['formConfig']['headline']
                            this.workflowSteps = res.data.content.form.flow
                            this.formPermissions = res.data.content.form.permissions
                            this.buttonConfig = res.data.content.form.buttonConfig
                            this.updateFormId = res.data.content.form._id.$oid

                            // if(Object.keys(res.data.content.form.tableObject).length !== 0){
                            //     this.tableData = res.data.content.form.tableObject['tableData']
                            //     this.tableName = res.data.content.form.tableObject['tableName']
                            //     this.tablePermissions = res.data.content.form.tableObject['tablePermissions']
                            //     this.showTable = true
                            // }
                            // if(Object.keys(res.data.content.form.fileObject).length !== 0){
                            //     this.filePermissions = res.data.content.form.fileObject['filePermissions']
                            //     this.showFile = true
                            // }
                            this.showList = false
                            this.$emit("changeHeader")
                            this.$root.$refs.Process.showPageHeader = false
                            this.isUpdateMode = true
                            this.changeTab('form')
                        }else{

                        }
                    }else{

                    }
                })
            },
            getUsersF() {
                axios({
                    method:'POST',
                    url:'/getUsers',
                    baseURL: this.baseUrl,
                    data: {
                    },
                    withCredentials:true
                    }).then((res)=>{
                        return res
                    }).then((res)=>{
                    if(res.data.status){
                        if(res.data.status.code==0){
                            this.user=res.data.content.user
                            this.users=res.data.content.users
                            this.permissions=res.data.content.permissions
                            this.getFormsF()
                        }
                    }
                })
            },
            changeStatu () {
                this.showList = false
                this.isUpdateMode = false
                // this.clearForm()
            },
            workflowStepsObj (data) {
                this.workflowSteps = data
            },
            changeTableName () {
                this.tableName = this.tableHeadline
                $('#changeTableName').modal('hide')
            },
            getTableData (data) {
                this.tableData = data
            },
            chooseFile(event){
                this.file = event.target.files[0]
            },
            checkRelatedInputs() {
                var check = true
                var builder = document.getElementById("formBuilder")
                var personElement = builder.getElementsByClassName("person-input")
                var companyElement = builder.getElementsByClassName("organization-input")
                var dealElement = builder.getElementsByClassName("deal-input")

                if( personElement.length > 1 || companyElement.length > 1 || dealElement.length > 1 ){
                    check = false
                }

                return check
            },
        },
        mounted() {
            this.getUsersF()
        }
    }
</script>
<style scoped>
    .pageHeader {
        background: #fff;
        color: #333333CC;
        position: absolute;
        width: 100%;
        left: 0;
        margin: 0;
        top: 60px;
        justify-content: center;
        align-items: center;
        z-index: 99;
    }
    .pageFooter {
        display: flex;
        background: #fff;
        color: #333333CC;
        position: absolute;
        width: 100%;
        bottom: -6%;
        height: 70px;
        align-items: center;
        left: 0;
        border-top: 1px solid rgba(139, 146, 158, 0.5);
        z-index: 99;
    }
    #formWorkflow, #formPermissions {
        margin-top: 80px;
    }
    .tabBtn {
        background: #E9EDF5;
        font-weight: 500;
        font-size: 14px;
        color: #333333CC;
        border-radius: 20px;
        min-width: 90px;
        padding: 0.5rem;
    }
    .currentTab .active {
        background: #009FF7;
        color: #FFFFFF;
        padding: 0.5rem;
    }
    .currentTab .active > .tab-number{
        background-color: #fff;
        color: #009FF7;
    }
    .add-table-section {
        width: 100%;
        padding: 30px 15px;
        border: 3px dotted rgba(0,0,0,.4);
    }
    .add-table-section:hover {
        border: 3px dotted rgba(0, 4, 255, 0.8);
    }
    .add-table-section > span {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        cursor: pointer;
    }
    .configure-table {
        display: none;
    }
    .table-content {
        padding: 15px;
        border: 2px solid transparent;
        position: relative;
    }
    .table-content:hover {
        border: 2px solid #0198fa;
        transition: all .2s ease-in-out;
    }
    .table-content:hover > .configure-table{
        display: flex;
        position: absolute;
        right: 15px;
    }
    .formHead {
        width: 35%;
        border: none;
        background: transparent;
        padding: 5px 5px;
        font-size: 34px;
        line-height: 46px;
        font-weight: 500;
        color: #333;
        border-bottom: 1px dashed #AFC2D9;
    }
    .tab-number {
        background-color: #D3D5DE;
        padding: 6px 9px;
        border-radius: 50%;
    }
    .scrollable {
        box-sizing: border-box;
        height: 80vh;
        overflow-y: scroll;
        background-color: #FFFFFF;
        margin-top: 7%;
        border-radius: 4px;
    }
    /* Hide scrollbar for Chrome, Safari and Opera */
    .scrollable::-webkit-scrollbar {
        display: none;
    }
    /* Hide scrollbar for IE, Edge and Firefox */
    .scrollable {
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
    }
    .formHead::-webkit-input-placeholder {
        /* WebKit, Blink, Edge */
        color: #a3a3a4;
    }
    .formHead:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #a3a3a4;
        opacity: 1;
    }
    .formHead::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #a3a3a4;
        opacity: 1;
    }
    .formHead:-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: #a3a3a4;
    }

    .custom-file-label{
        padding-left:80px;
        color: #D1D1D7;
        font-size: 14px;
        font-weight: 500;
        line-height: 24px;
        overflow: hidden;
    }
    .custom-file-label::after{
        left: 0;
        right: auto;
        content: "Göz At";
        border: 1px solid rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        background-color: #3767a0 !important;
        cursor: pointer !important;
        color: #fff !important;
    }
    .addFile{
        background-color: #FAFAFA;
        border: 1px solid #E7E7E8;
        box-sizing: border-box;
        border-radius: 4px;
    }
</style>